import { WorkflowLocation } from "../types/types"
import { genericRequest, locationRoute } from "./service"

/**
 * Gets all workflow locations.
 * 
 * @returns list of workflow locations.
 */
export const getLocations = async (): Promise<WorkflowLocation[] | Error> => {
  return await genericRequest({ url: `${locationRoute}/`, method: "GET" })
}
